import { ref } from '@vue/composition-api'

export function useLoading() {
  const isLoading = ref(false)
  const runPromise = async (fn: () => Promise<unknown>) => {
    isLoading.value = true
    try {
      return await fn()
    } finally {
      isLoading.value = false
    }
  }
  return { isLoading, runPromise }
}
